import { useEffect, useState } from "react";
import api, { API } from "../../lib/api";

// The Coming-Soon backdrop: the owner's publicly shared before/after cards, pinned to a warm wall and repeated to
// fill it. No cards yet = the bare wall.
const BACKEND = API.replace(/\/api$/, "");
const TILT = [-4, 3, -2, 5, -3, 2, -5, 4, -1, 3, -4, 1, 5, -2];
const TILES = 48;

const useWallCards = () => {
  const [cards, setCards] = useState([]);
  useEffect(() => {
    let live = true;
    api.get("/public/login-wall")
      .then(({ data }) => live && setCards(data?.cards || []))
      .catch(() => {});
    return () => { live = false; };
  }, []);
  return cards;
};

export const DuckWall = () => {
  const cards = useWallCards();
  return (
    <div data-testid="login-duck-wall" data-cards={cards.length} aria-hidden="true" className="absolute inset-0 overflow-hidden bg-[#efe4cc]">
      <div className="absolute inset-0 opacity-50 [background-image:radial-gradient(#d8c69e_1px,transparent_1px)] [background-size:14px_14px]" />
      {cards.length > 0 && (
        <div className="absolute -inset-10 grid grid-cols-3 sm:grid-cols-4 lg:grid-cols-6 xl:grid-cols-8 gap-6 sm:gap-8 p-6 sm:p-10">
          {Array.from({ length: TILES }, (_, i) => (
            <figure
              key={i}
              className="login-print relative bg-white p-2 pb-7 shadow-[0_10px_24px_-12px_rgba(60,40,10,0.45)]"
              style={{ transform: `rotate(${TILT[i % TILT.length]}deg)`, animationDelay: `${(i % 12) * 60}ms` }}
            >
              <span className="absolute -top-2 left-1/2 h-4 w-12 -translate-x-1/2 rotate-[-3deg] bg-[#ffc700]/70" />
              <img src={`${BACKEND}${cards[i % cards.length]}`} alt="" loading="lazy" className="aspect-[4/5] w-full object-cover" draggable="false" />
            </figure>
          ))}
        </div>
      )}
      <div className="absolute inset-0 bg-gradient-to-r from-[#efe4cc] via-[#efe4cc]/80 to-transparent lg:via-[#efe4cc]/55" />
    </div>
  );
};
